import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { teamsService } from '../../../../../../app/services/teamsService'
import { UpdateTeamdata } from '../../../../../../app/services/teamsService/updateTeam'
import { useToast } from '../../../../../components/ui/use-toast'
import {
  UserRoleDicionary,
  UserRoleEnum,
} from '@/app/services/usersService/user'

export const useRemoveExecutivesController = () => {
  const { id } = useParams()
  const queryClient = useQueryClient()
  const { toast } = useToast()

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['AddMember'],
    mutationFn: async ({
      teamId,
      memberId,
    }: {
      teamId: string
      memberId: UpdateTeamdata
    }) => await teamsService.updateTeam(memberId, teamId),
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ['teamId', id],
      })
    },
  })

  const handleRemove = async (
    role: UserRoleEnum.MANAGER | UserRoleEnum.SUPERVISOR | UserRoleEnum.LEADER,
  ) => {
    try {
      await mutateAsync({
        teamId: id!,
        memberId: {
          manager_id: role === UserRoleEnum.MANAGER ? null : undefined,
          supervisor_id: role === UserRoleEnum.SUPERVISOR ? null : undefined,
          leader_id: role === UserRoleEnum.LEADER ? null : undefined,
        },
      })

      toast({
        title: `${UserRoleDicionary[role]} removido com sucesso.`,
      })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.log(error)
      toast({
        variant: 'destructive',
        title:
          error.message ||
          `Erro ao atualizar o ${UserRoleDicionary[role]}, tente novamente mais tarde`,
      })
    }
  }

  return {
    handleRemove,
    isPending,
  }
}
